<script>
import Breadcrumb from "../../geral/Breadcrumb.vue";
import Moment from "moment/moment";
import ExcluirMetodoAutenticacaoModal from "./ExcluirMetodoAutenticacaoModal.vue";

export default {
  name: "GerenciarMetodosAutenticacao",
  components: {ExcluirMetodoAutenticacao: ExcluirMetodoAutenticacaoModal, Breadcrumb},
  props: {
    certificado: {
      type: Object,
      required: true,
      default: () => {}
    },
    sistemas: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      showExcluirModal: false,
      origemTribunalIds: null
    }
  },
  filters: {
    date(value) {
     return Moment(value).format('DD/MM/YYYY')
    }
  },
  methods: {
    abrirExcluirModal(ids) {
      this.origemTribunalIds = ids;
      this.showExcluirModal = true;
    },
    fecharExcluirModal() {
      this.origemTribunalIds = null;
      this.showExcluirModal = false;
    },
  }
}
</script>

<template>
  <div>
    <Breadcrumb :items="[
        { text: 'Certificados Digitais', to: '/certificados' },
        { text: certificado['pessoa_nome'].toUpperCase(), active: true }
      ]" />

    <div class="justify-between flex flex-wrap separate-section gap-2.5">
      <h1 class="text-2xl font-bold m-0">Gerenciar Métodos de Autenticação</h1>
      <btn class="btn info" :href="`/certificados/${certificado['id']}/metodos-autenticacao/adicionar`">
          Adicionar Método de Autenticação
      </btn>
    </div>

    <div class="mt">
      <div class="bg-white p-4 rounded-md shadow mb-6 border border-gray-200">
        <h2 class="text-xl font-semibold text-gray-700">Certificado Selecionado:</h2>
        <p class="m-0">
          <strong class="text-gray-500">Nome:</strong>
          <span>
            {{ certificado['pessoa_nome'].toUpperCase() }}
          </span>
        </p>
        <p class="m-0">
          <strong class="text-gray-500">CPF:</strong>
          <span>
            {{ certificado['pessoa_cpf'] }}
          </span>
        </p>
      </div>

      <div>
        <h2 class="text-xl font-semibold">Métodos Configurados</h2>

        <template v-if="sistemas.length > 0">
          <div v-for="sistema in sistemas" class="bg-white p-4 rounded-md shadow border border-gray-200 mb-3 gap-2.5 flex flex-col md:flex-row justify-between md:items-center">
            <div>
              <p class="font-semibold text-gray-800 m-0">
                {{ sistema['nome'] }} (TOTP)
              </p>
              <p class="text-sm text-gray-500 m-0">Configurado para {{ sistema.ids.length }} {{ sistema.ids.length > 1 ? 'sistemas' : 'sistema' }}</p>
            </div>
            <div>
              <Btn class="btn info" :href="`/certificados/${certificado['id']}/metodos-autenticacao/adicionar?sistema_selecionado=${sistema['id']}`">
                Editar
              </Btn>
              <Btn class="btn negative"
                   @click="abrirExcluirModal(sistema.ids)">
                Excluir
              </Btn>
            </div>
          </div>
        </template>

        <div v-else class="p-4 alert-warning font-semibold">
          <p class="m-0">Nenhum método de autenticação configurado para este certificado.</p>
        </div>
      </div>
    </div>

    <excluir-metodo-autenticacao
      v-if="showExcluirModal"
      :origem-tribunal-sistemas-ids="origemTribunalIds"
      :certificado-id="certificado.id"
      @closeModal="fecharExcluirModal"
      >
    </excluir-metodo-autenticacao>
  </div>
</template>

<style scoped lang="stylus">
.alert-warning
  border-left 4px solid #facc15
  background-color #fefce8

  & p
   color #a16207
</style>
